export const ENDPOINTS_CACHE_KEY = 'endpoints'
export const PKCE_CACHE_KEY = 'pkce-verifier'
export const STATE_CACHE_KEY = 'auth-state'

/**
 * Event name dispatched when session validation detects the user is no longer authenticated.
 * Applications can listen to this event to show the session expired modal.
 */
export const SESSION_EXPIRED_EVENT = 'session-expired'

export const MAX_PASSWORD_LENGTH = 64

export const VALID_PASSWORD_REGEXP = new RegExp(
  `^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))[\\s\\S]{8,${MAX_PASSWORD_LENGTH}}$`,
)
